import { DriverLicenceInfoParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDriverLicenceInfo/driverLicenceInfoQuery.type';
import { driverLicenceInfoQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDriverLicenceInfo/driverLicenceInfoQueryFunction';
import { useMutation } from '@tanstack/react-query';

const useDriverLicenceInfoQuery = () => {
  return useMutation({
    mutationFn: (params: DriverLicenceInfoParamsType) =>
      driverLicenceInfoQueryFunction(params),
    mutationKey: ['driverLicenceInfoQuery'],
  });
};

export { useDriverLicenceInfoQuery };
